/**
 * Q Labs Loading Phrases
 *
 * Witty, James Bond-inspired loading messages for the interview experience.
 * Work-appropriate but with that Q Labs flair.
 */

const LOADING_PHRASES = [
  // Q Labs Tech
  'Calibrating the requirements scanner...',
  'Warming up the analysis circuits...',
  'Polishing the monocle of insight...',
  'Engaging proprietary Q-tech...',
  'Running diagnostics on the clever bits...',
  'Synchronizing with HQ...',
  'Deploying invisible ink algorithms...',
  'Activating the think tank...',
  'Consulting the gadget manual...',
  'Initializing covert analysis protocols...',

  // Spy Craft
  'Scanning for requirements in plain sight...',
  'Decoding your specifications...',
  'Establishing secure requirements channel...',
  'Reviewing the dossier...',
  'Cross-referencing with field intelligence...',
  'Analyzing the mission parameters...',
  'Preparing the briefing materials...',
  'Checking for hidden requirements...',
  'Sweeping for ambiguities...',
  'Verifying secure connection to brain trust...',

  // Witty One-liners
  "The name's Cortex. Requirements Cortex...",
  'Shaken, not stirred... just like your codebase...',
  'Do pay attention, 007... I mean, user...',
  'I never joke about requirements...',
  'Expecting someone else?',
  "I've been expecting you...",
  'Ah, the legendary requirements gatherer...',
  'License to clarify...',
  'For your requirements only...',
  'The specs are not enough...',

  // Tech Humor
  'Teaching AI to understand humans (the hard part)...',
  'Converting coffee to requirements...',
  'Parsing your brilliant ideas...',
  'Untangling the complexity matrix...',
  'Refactoring expectations...',
  'Debugging the requirements pipeline...',
  'Compiling thoughts into actionable items...',
  'Optimizing the question queue...',
  'Running semantic analysis...',
  'Deploying empathy protocols...',

  // Professional with Flair
  'Preparing intelligent questions...',
  'Loading context awareness module...',
  'Analyzing project structure...',
  'Building mental model...',
  'Studying the mission brief...',
  'Preparing clarifying questions...',
  'Loading domain expertise...',
  'Contextualizing your request...',
  'Formulating the perfect opening...',
  'Ready to assist momentarily...',

  // More Q References
  'Now pay attention, this is important...',
  'Ah yes, the new equipment...',
  'Try not to break this one...',
  'Standard operating procedure, really...',
  'I designed this myself, you know...',
  'Rather proud of this one...',
  'Fresh from the Q Branch labs...',
  'Top secret, naturally...',
  'Clearance level: requirements analyst...',
  'The latest in interview technology...',

  // Cheeky
  'Making this look effortless...',
  'Pretending to think very hard...',
  'Actually reading your description (shocking, I know)...',
  'Resisting urge to ask obvious questions...',
  'Suppressing generic responses...',
  'Loading personality subroutines...',
  'Activating charm module...',
  'Engaging wit processors...',
  'Preparing devastatingly good questions...',
  'Almost ready to dazzle you...',

  // Encouraging
  'Your requirements are in good hands...',
  "This won't take long...",
  'Preparing to make your life easier...',
  'Getting ready to understand you...',
  'Warming up the helpful algorithms...',
  'Preparing to cut through the noise...',
  'Loading efficiency protocols...',
  'Ready to save you time...',
  'Preparing to exceed expectations...',
  'Almost ready to impress...',

  // Technical Bond
  'Quantum requirements processing...',
  'Goldeneye analysis engaged...',
  'Thunderball algorithms loading...',
  'Octopussy-level multitasking...',
  'Living daylights processing...',
  'Tomorrow never dies... but this loading will...',
  'Casino royale-grade analysis...',
  'Skyfall-proof requirements gathering...',
  'Spectre of bad requirements: eliminated...',
  'No time to die... waiting for AI...',

  // Self-Aware
  "Yes, I'm actually reading your request...",
  'Promise not to ask what you already told me...',
  'Loading context-awareness (revolutionary, I know)...',
  'Preparing non-redundant questions...',
  "Calibrating the 'actually helpful' module...",
  "Disabling the 'repeat yourself' subroutine...",
  "Engaging 'pay attention' mode...",
  "Loading 'respect your time' protocols...",
  "Activating 'skip the obvious' filter...",
  'Ready to be genuinely useful...',
] as const;

/**
 * Get a random loading phrase
 */
export function getRandomPhrase(): string {
  const index = Math.floor(Math.random() * LOADING_PHRASES.length);
  return LOADING_PHRASES[index] ?? 'Analyzing your requirements...';
}
